import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute: React.FC = () => {
  // Consider the session valid if we have ANY token.
  // The axios interceptor will silently refresh the access
  // token on the next API call if it's missing or expired.
  const hasAccess = !!localStorage.getItem('accessToken');
  const hasRefresh = !!localStorage.getItem('refreshToken');
  const hasAdmin = !!localStorage.getItem('admin_data');

  if (!hasAccess && !hasRefresh) {
    return <Navigate to="/login" replace />;
  }

  // If we have tokens but no admin_data, fall through anyway.
  // The next API call will re-populate the admin (via /auth/me).
  // (Only bounce if literally nothing is stored.)
  if (!hasAdmin && !hasAccess && !hasRefresh) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;